<mip-modal size="full" position="fixed">
  <div class="stories__users">
    <mip-stories-slider
      class="user-stories"
      [class.profile-stories--is-mobile]="isMobile"
      [profile]="profile"
      [stories]="stories"
    ></mip-stories-slider>
  </div>
</mip-modal>
